export const DEFAULT_ZOOM_LEVEL = 10;
export const UK_MARKETPLACE_ID = "EBAY-GB";
export const DE_MARKETPLACE_ID = "EBAY-DE";
export const LONDON_CENTER: google.maps.LatLngLiteral = {
  lat: 51.506307,
  lng: -0.145552,
};
export const BERLIN_CENTER: google.maps.LatLngLiteral = {
  lat: 52.520008,
  lng: 13.404954,
};
export const UNKNOWN_POSITION: google.maps.LatLngLiteral = {
  lat: 0,
  lng: 0,
};
export const DEFAULT_MAP_PADDING = 1;
export const DEFAULT_RADIUS_M = 30000;
export const DEFAULT_CLUSTER_RADIUS = 10;
export const DEFAULT_EXTENT = 70;
export const MAX_ZOOM_LEVEL = 20;
export const SHOW_CIRCLES_ZOOM_LEVEL = 15;
export const CIRCLE_STROKE_COLOR = "#3665F3";
export const CIRCLE_STROKE_WEIGHT = 1.5;
export const ACTIVE_CIRCLE_FILL_OPACITY = 0.1;
export const STACKED_CLUSTER_PRECISION = 5;
export const MARKER_Z_INDEX = 1;
export const ACTIVE_MARKER_Z_INDEX = 1000;
